import React, { useState } from "react";

import {
  Content,
  FormVaga,
  SelectTipo,
  Linha,
  ContainerRequisitos,
  StyledTag,
  Button,
  ContainerPassos,
  Passo,
  AnimatedDone,
  ContainerDone,
  BarraProgresso,
  Dicas,
} from "./styles";
import { Container } from "../../../styles/GlobalStyles";

import Header from "../../../components/Header";
import { FaGrinHearts, FaInfoCircle } from "react-icons/fa";
import Input from "../../../components/Input";
import InputCurrency from "../../../components/InputCurrency";
import TextArea from "../../../components/TextArea";
import { useHistory } from "react-router-dom";
import { api } from "../../../services/api";

function NovaVaga() {
  const history = useHistory();
  const headerLinks = [{ label: "Sair", to: "/" }];

  const [passo, setPasso] = useState(1);

  const [novaVaga, setNovaVaga] = useState({
    tipo: 1,
    cargo: "",
    qtdVagas: 1,
    atribuicoes: "",
    requisitos: [],
    local: "",
    horario: "",
    salario: "",
    beneficios: [],
    observacoes: "",
    publica: true,
  });

  const handlerInput = (e) => {
    setNovaVaga({ ...novaVaga, [e.target.id]: e.target.value });
  };

  const handlerPublica = (e) => {
    setNovaVaga({ ...novaVaga, publica: !novaVaga.publica });
  };

  const handlerAvancar = () => {
    setPasso(passo + 1);
  };

  const handlerVoltar = () => {
    setPasso(passo - 1);
  };

  const enviar = async (e) => {
    e.preventDefault();

    try {
      const retorno = await api.post("/vagas", novaVaga);

      console.log(retorno);

      setNovaVaga({ ...novaVaga, id: retorno.data.id });

      setPasso(5);
    } catch (e) {
      console.error(e);
    }
  };

  const buscarAlunos = () => {
    history.replace("/empresa/buscar-alunos", { vaga: novaVaga });
  };

  return (
    <Container>
      <Header links={headerLinks} theme="black" />
      <Content>
        <header>
          <h2>
            É ótimo ver você anunciando uma vaga aqui!{" "}
            <FaGrinHearts size={30} />
          </h2>
          <ContainerPassos>
            <BarraProgresso width={25 * (passo - 1)} />
            <Passo concluido={passo > 1} atual={passo === 1}>
              1
            </Passo>
            <Passo concluido={passo > 2} atual={passo === 2}>
              2
            </Passo>
            <Passo concluido={passo > 3} atual={passo === 3}>
              3
            </Passo>
            <Passo concluido={passo > 4} atual={passo === 4}>
              4
            </Passo>
            <Passo concluido={passo === 5} atual={passo === 5}>
              5
            </Passo>
          </ContainerPassos>
        </header>
        {passo === 1 && (
          <FormPasso1
            dados={novaVaga}
            handlerInput={handlerInput}
            avancar={handlerAvancar}
          />
        )}
        {passo === 2 && (
          <FormPasso2
            dados={novaVaga}
            setDados={setNovaVaga}
            handlerInput={handlerInput}
            voltar={handlerVoltar}
            avancar={handlerAvancar}
          />
        )}
        {passo === 3 && (
          <FormPasso3
            dados={novaVaga}
            setDados={setNovaVaga}
            handlerInput={handlerInput}
            voltar={handlerVoltar}
            avancar={handlerAvancar}
          />
        )}
        {passo === 4 && (
          <FormPasso4
            dados={novaVaga}
            handlerInput={handlerInput}
            handlerPublica={handlerPublica}
            voltar={handlerVoltar}
            enviar={enviar}
          />
        )}
        {passo === 5 && <Fim buscarAlunos={buscarAlunos} dados={novaVaga} />}
      </Content>

      <h2 style={{ display: "flex", alignItems: "center" }}>
        <FaInfoCircle size={20} style={{ margin: 5, padding: 0 }} />
        Dicas
      </h2>
      <Dicas>
        <li>Os campos com * são obrigatórios.</li>
        <li>
          As oportunidades cadastradas aqui serão veiculadas em nossos murais.
        </li>
        <li>
          Após o cadastro, você poderá direcionar a vaga para grupos de
          alunos.
        </li>
        <li>
          Esses alunos serão notificados, aumentando o alcance da oportunidade.
        </li>
      </Dicas>
    </Container>
  );
}

const FormPasso1 = ({ avancar, dados, handlerInput }) => {
  return (
    <FormVaga onSubmit={avancar}>
      <Linha>
        <h1>Qual é o perfil da vaga?</h1>
      </Linha>

      <SelectTipo
        label="Tipo da Vaga *"
        id="tipo"
        handler={handlerInput}
        value={dados.tipo}
      >
        <option value="1">Estágio</option>
        <option value="2">Emprego</option>
        <option value="3">Temporário</option>
      </SelectTipo>
      <span />
      <Input
        type="text"
        label="Cargo *"
        id="cargo"
        value={dados.cargo}
        handler={handlerInput}
        placeholder="Exemplo: Analista de suporte TI"
        required
      />
      <Input
        type="number"
        label="Quantidade de vagas *"
        id="qtdVagas"
        handler={handlerInput}
        value={dados.qtdVagas}
        placeholder="99"
        required
      />

      <span />
      <Button direction="right" color="green">
        Próximo
      </Button>
    </FormVaga>
  );
};

const FormPasso2 = ({ avancar, voltar, dados, setDados, handlerInput }) => {
  const [requisito, setRequisito] = useState("");
  const [requisitos, setRequisitos] = useState(dados.requisitos);

  const handlerRequisito = (e) => {
    setRequisito(e.target.value);
  };

  const handlerPutTag = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      requisitos.push(requisito);
      setRequisito("");
    }
  };

  const apagarRequisito = (req) => {
    let reqs = requisitos.slice();
    reqs.splice(reqs.indexOf(req), 1);
    setRequisitos(reqs);
  };

  const handlerSubmit = (e) => {
    e.preventDefault();

    if (requisito.length > 0) {
      requisitos.push(requisito);
      setRequisito("");
    }

    setDados({ ...dados, requisitos });

    avancar();
  };

  return (
    <FormVaga onSubmit={handlerSubmit}>
      <Linha>
        <h1>Conte-nos mais sobre a vaga</h1>
      </Linha>
      <Linha>
        <TextArea
          placeholder="Exemplo: O profissional irá atuar junto a equipe de plataforma de frete (desenvolvedores, arquitetos, cientistas de dados e analistas de negócio), com o papel de estudar novas tecnologias e implementar projetos de inovação de alta escalabilidade e disponibilidade, alta performance, resilientes e orientada a eventos, além participar da arquitetura de microsserviços que atuam na estrutura de frete da companhia."
          label="Responsabilidades e Atribuições *"
          id="atribuicoes"
          handler={handlerInput}
          value={dados.atribuicoes}
          required
        />
      </Linha>
      <Input
        type="text"
        label="Pré-Requisitos"
        value={requisito}
        tip="Pressione enter para adicionar"
        handler={handlerRequisito}
        handlerKeyDown={handlerPutTag}
        placeholder="Exemplo: 6 meses de experiência, Superior completo"
      />
      <Linha style={{ marginTop: -20 }}>
        <ContainerRequisitos>
          {requisitos.map((r, i) => (
            <Tag key={i} info={r} handlerClose={apagarRequisito} />
          ))}
        </ContainerRequisitos>
      </Linha>
      <Button type="button" direction="left" color="primary" onClick={voltar}>
        Voltar
      </Button>
      <Button direction="right" color="green">
        Próximo
      </Button>
    </FormVaga>
  );
};

const FormPasso3 = ({ avancar, voltar, dados, setDados, handlerInput }) => {
  const [beneficio, setBeneficio] = useState("");
  const [beneficios, setBeneficios] = useState(dados.beneficios);

  const handlerBeneficio = (e) => {
    setBeneficio(e.target.value);
  };

  const apagarBeneficio = (req) => {
    let reqs = beneficios.slice();
    reqs.splice(reqs.indexOf(req), 1);
    setBeneficios(reqs);
  };

  const handlerSubmit = (e) => {
    e.preventDefault();

    if (beneficio.length > 0) {
      beneficios.push(beneficio);
      setBeneficio("");
    }

    setDados({ ...dados, beneficios });

    avancar();
  };

  const handlerPutTag = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (beneficio.trim() !== "") {
        beneficios.push(beneficio.trim());
        setBeneficio("");
      }
    }
  };

  // const handlerSalario = (e) => {
  //   e.target.value.replace(/[^0-9]+/g, "");
  //   let value = "";

  //   setDados({
  //     ...dados,
  //     salario: value,
  //   });
  // };

  return (
    <FormVaga onSubmit={handlerSubmit}>
      <Linha>
        <h1>Informe para os candidatos</h1>
      </Linha>
      <Input
        type="text"
        id="local"
        value={dados.local}
        handler={handlerInput}
        label="Local de Trabalho *"
        placeholder="Exemplo: Rua Carmine 664 Centro Jandira São Paulo"
        required
      />

      <InputCurrency
        type="number"
        id="salario"
        value={dados.salario}
        handler={handlerInput}
        label="Salário"
        placeholder="Exemplo: 3000"
      />
      <TextArea
        type="text"
        id="horario"
        value={dados.horario}
        handler={handlerInput}
        label="Horário *"
        placeholder="Exemplo: Seg à sexta - 08:00 às 17:00
Sábado - 8:30 às 13:00"
        required
      />
      <Linha>
        <Input
          type="text"
          value={beneficio}
          handler={handlerBeneficio}
          label="Benefícios"
          tip="Pressione enter para adicionar"
          handlerKeyDown={handlerPutTag}
          placeholder="Exemplo: Vale Refeição, Transporte"
        />
      </Linha>
      <Linha style={{ marginTop: -20 }}>
        <ContainerRequisitos>
          {beneficios.map((r, i) => (
            <Tag key={i} info={r} handlerClose={apagarBeneficio} />
          ))}
        </ContainerRequisitos>
      </Linha>
      <Button type="button" direction="left" color="primary" onClick={voltar}>
        Voltar
      </Button>
      <Button direction="right" color="green">
        Próximo
      </Button>
    </FormVaga>
  );
};

const FormPasso4 = ({
  enviar,
  voltar,
  dados,
  handlerInput,
  handlerPublica,
}) => {
  return (
    <FormVaga onSubmit={enviar}>
      <Linha>
        <h1>Algo mais?</h1>
      </Linha>
      <Linha>
        <TextArea
          id="observacoes"
          value={dados.observacoes}
          handler={handlerInput}
          placeholder="Exemplo: Será um diferencial para a vaga conhecimentos em gestão de projetos."
          label="Observações"
        />
      </Linha>
      <Linha>
        <div style={{ display: "none", alignItems: "center" }}>
          <input
            type="checkbox"
            id="publico"
            style={{ width: 18, marginRight: 5 }}
            checked={dados.publica}
            onChange={handlerPublica}
          />
          <label>Veicular vaga no mural público</label>
        </div>
      </Linha>
      <Button type="button" direction="left" color="primary" onClick={voltar}>
        Voltar
      </Button>
      <Button direction="right" color="green">
        Salvar Vaga
      </Button>
    </FormVaga>
  );
};

const Fim = ({ buscarAlunos }) => {
  return (
    <ContainerDone>
      Tudo certo!
      <AnimatedDone size={120} />
      Sua vaga já está cadastrada, agora precisamos direcioná-la aos alunos
      certos.
      <br />
      <br />
      <Button color="green" onClick={buscarAlunos}>
        Buscar Alunos
      </Button>
    </ContainerDone>
  );
};

const Tag = ({ info, handlerClose }) => {
  return (
    <StyledTag>
      {info}
      <span
        onClick={() => {
          handlerClose(info);
        }}
      >
        &times;
      </span>
    </StyledTag>
  );
};

export default NovaVaga;
